import { useEffect, useState } from "react";
import makeAnimated from "react-select/animated";
import Select from "react-select";

import useCompany from "../../../Hooks/useCompany";
import useReport from "../../../Hooks/useReport";
import useProspect from "../../../Hooks/useProspect";

import DatePicker from "react-datepicker";
import isValid from "date-fns/isValid";
import subDays from "date-fns/subDays";
import addDays from "date-fns/addDays";
import format from "date-fns/format";
import "react-datepicker/dist/react-datepicker.css";

import { Card, CardBody } from "../../../Components/Card";
import { Text } from "../../../Components/Text";
import { Column, Row } from "../../../Components/Layout";
import { Button } from "../../../Components/Button";

const Filters = () => {
  const animatedComponents = makeAnimated();

  const { listCompany } = useCompany();
  const { indexProspectList } = useReport();
  const { listProspectStatus } = useProspect();

  const today = new Date();

  const [startDate, setStartDate] = useState(today.setDate(1));
  const [validStartDate, setValidStartDate] = useState("");

  const [endDate, setEndDate] = useState(
    new Date(today.getFullYear(), today.getMonth() + 1, 0)
  );
  const [validEndDate, setValidEndDate] = useState("");

  const [unit, setUnit] = useState();
  const [listUnits, setListUnits] = useState([]);
  const [validUnits, setValidUnits] = useState("");

  const [status, setStatus] = useState({ value: "all", label: "Todos" });
  const [listStatus, setListStatus] = useState([]);

  useEffect(() => {
    if (listProspectStatus) {
      handleListStatus();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (listCompany) {
      setListUnits(listCompany);
    }
  }, [listCompany]);

  const handleStartDateChange = (date) => {
    setStartDate(date);
    setValidStartDate(isValid(date) ? "" : "Data inválida");
  };

  const handleEndDateChange = (date) => {
    setEndDate(date);
    setValidEndDate(isValid(date) ? "" : "Data inválida");
  };

  const handleCompany = (e) => {
    setUnit(e);
    setValidUnits(e ? "" : "Selecione uma empresa");
  };

  const handleListStatus = () => {
    let list = [{ value: "all", label: "Todos" }];
    listProspectStatus.data.forEach((data) => {
      list.push({ value: data.id, label: data.name });
    });
    setListStatus(list);
  };

  const handleValidate = () => {
    let valid = true;

    if (!isValid(startDate)) {
      setValidStartDate("Data inicial inválida");
      valid = false;
    } else {
      setValidStartDate("");
    }

    if (!isValid(endDate)) {
      setValidEndDate("Data final inválida");
      valid = false;
    } else {
      setValidEndDate("");
    }

    if (!unit || unit.value === undefined) {
      setValidUnits("Selecione uma empresa");
      valid = false;
    } else {
      setValidUnits("");
    }

    return valid;
  };

  const handleFilter = () => {
    if (handleValidate()) {
      let params = {
        start_date: format(startDate, "yyyy-MM-dd 00:00:00"),
        end_date: format(endDate, "yyyy-MM-dd 23:59:59"),
        company: unit.value,
        status: status.value,
      };

      indexProspectList(params);
    }
  };

  return (
    <Card bgColor="white" marginBottom="3" padding="2">
      <CardBody>
        <Row>
          <Column col="6" md="2">
            <Text tag="h6">Data Início</Text>
            <DatePicker
              locale="ptBR"
              selected={startDate}
              onChange={(date) => handleStartDateChange(date)}
              onBlur={() => handleStartDateChange(startDate)}
              dateFormat="dd/MM/yyyy"
              portalId="root"
              className={
                validStartDate
                  ? "form-control is-invalid bg-white"
                  : "form-control bg-white"
              }
              maxDate={endDate}
              minDate={subDays(endDate, 60)}
            />
            {validStartDate && (
              <div className="invalid-feedback">{validStartDate}</div>
            )}
          </Column>
          <Column col="6" md="2">
            <Text tag="h6">Data Final</Text>
            <DatePicker
              locale="ptBR"
              selected={endDate}
              onChange={(date) => handleEndDateChange(date)}
              onBlur={() => handleEndDateChange(endDate)}
              dateFormat="dd/MM/yyyy"
              portalId="root"
              className={
                validEndDate
                  ? "form-control is-invalid bg-white"
                  : "form-control bg-white"
              }
              minDate={startDate}
              maxDate={addDays(startDate, 60)}
            />
            {validEndDate && (
              <div className="invalid-feedback">{validEndDate}</div>
            )}
          </Column>
          <Column col="12" md="3">
            <Text tag="h6">Unidades</Text>
            <Select
              closeMenuOnSelect={true}
              components={animatedComponents}
              value={unit}
              options={listUnits}
              onChange={handleCompany}
              menuPosition={"fixed"}
              className={validUnits && "form-control is-invalid bg-white"}
            />
            {validUnits && <div className="invalid-feedback">{validUnits}</div>}
          </Column>
          <Column col="12" md="3">
            <Text tag="h6">Status</Text>
            <Select
              closeMenuOnSelect={true}
              components={animatedComponents}
              defaultValue={[{ value: "all", label: "Todos" }]}
              value={status}
              options={listStatus}
              menuPosition={"fixed"}
              onChange={(e) => setStatus(e)}
            />
          </Column>

          <Column col="12" md="2" top marginTop="3">
            <Button
              txtAlign="center"
              bgColor="info"
              width
              txtColor="white"
              marginTop="2"
              onClick={handleFilter}
              id="btn-filter-campaign"
            >
              <Text tag="i" className="fa fa-filter" marginRight="2" />
              <Text tag="small">Filtrar</Text>
            </Button>
          </Column>
        </Row>
      </CardBody>
    </Card>
  );
};

export default Filters;
